import * as React from 'react';

import type { LocationWithCoordinates } from 'lib/types';
import type { BookingStep } from '@bondvet/types/booking';
import BookingContext from './context';

type BookingContextProviderProps = {
    citySlug?: string;
    locationSlug?: string;
    location?: LocationWithCoordinates;
    step: BookingStep;
};

export default function BookingContextProvider({
    citySlug,
    locationSlug,
    children,
    location,
    step,
}: React.PropsWithChildren<BookingContextProviderProps>) {
    const context = React.useMemo(
        () => ({ step, citySlug, locationSlug, location }),
        [step, citySlug, locationSlug, location],
    );

    return (
        <BookingContext.Provider value={context}>
            {children}
        </BookingContext.Provider>
    );
}
